var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthiopia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M0 0H1200V600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0H1200V400H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 0H1200V200H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6666667,0,0,1.6666667,600,300)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 120,
    fill: "#0f47af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,-96 -4.205849,12.944272 17.347494,53.390097 H -9.987258 l -2.599358,8 h 74.162668 l 11.011056,-8 H 21.553343 Z",
    fill: "#fcdd09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,44 V 96",
    transform: "rotate(-144)",
    stroke: "#fcdd09",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(144)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-144)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72)",
    width: "100%",
    height: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/Ethiopia.d1fb1f2d03c05312941ce5b877e3dd2e.svg";
export { ForwardRef as ReactComponent };